"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSentenceTimings = computeSentenceTimings;
/**
 * Sentence timing utilities
 * Используются для диктантов и пошагового воспроизведения предложений поверх одного аудиофайла.
 */
const textTokenizer_1 = require("./textTokenizer");
function normalizeWord(raw) {
    return raw
        .toLowerCase()
        .replace(/^[^\p{L}\p{N}]+|[^\p{L}\p{N}]+$/gu, "")
        .trim();
}
/**
 * Сопоставляет последовательность word boundaries с предложениями.
 * Предположение: Azure выдаёт boundary только для лексических слов (без чистой пунктуации).
 */
function computeSentenceTimings(content, wordBoundaries, opts = {}) {
    const language = opts.language;
    const sentences = opts.sentences && opts.sentences.length > 0
        ? opts.sentences
        : (0, textTokenizer_1.splitIntoSentencesForDictation)(content, language);
    const normalizedBoundaryWords = wordBoundaries
        .map((w) => normalizeWord(w.word))
        .filter(Boolean);
    const totalBoundaries = normalizedBoundaryWords.length;
    let boundaryCursor = 0;
    const timings = [];
    for (let i = 0; i < sentences.length; i++) {
        const sentence = sentences[i];
        const tokens = (0, textTokenizer_1.tokenizeText)(sentence, language);
        const sentenceWords = tokens
            .filter((t) => t.isWord)
            .map((t) => normalizeWord(t.text))
            .filter(Boolean);
        const wordCount = sentenceWords.length;
        if (wordCount === 0) {
            // Пустое / безсловесное предложение — пропускаем, но ставим нулевой тайминг к предыдущему концу.
            const lastEnd = timings.length > 0 ? timings[timings.length - 1].end : 0;
            timings.push({
                index: i,
                text: sentence,
                start: lastEnd,
                end: lastEnd,
                wordStartIndex: boundaryCursor,
                wordEndIndex: boundaryCursor - 1,
            });
            continue;
        }
        const startBoundaryIndex = boundaryCursor;
        const endBoundaryIndex = Math.min(boundaryCursor + wordCount - 1, totalBoundaries - 1);
        if (startBoundaryIndex >= totalBoundaries) {
            // Boundary закончились – линеарно экстраполируем последние интервалы
            const lastEnd = timings.length > 0 ? timings[timings.length - 1].end : 0;
            const estimatedDuration = 800 * wordCount; // эвристика
            timings.push({
                index: i,
                text: sentence,
                start: lastEnd,
                end: lastEnd + estimatedDuration,
                wordStartIndex: totalBoundaries,
                wordEndIndex: totalBoundaries - 1,
            });
            continue;
        }
        const startOffset = wordBoundaries[startBoundaryIndex].offset;
        const endOffset = wordBoundaries[endBoundaryIndex].offset +
            wordBoundaries[endBoundaryIndex].duration;
        timings.push({
            index: i,
            text: sentence,
            start: startOffset,
            end: endOffset,
            wordStartIndex: startBoundaryIndex,
            wordEndIndex: endBoundaryIndex,
        });
        boundaryCursor += wordCount;
    }
    // Корректировка перекрытий / регрессий (монотонность времени)
    for (let i = 1; i < timings.length; i++) {
        if (timings[i].start < timings[i - 1].end) {
            timings[i].start = timings[i - 1].end;
            if (timings[i].end < timings[i].start) {
                timings[i].end = timings[i].start;
            }
        }
    }
    return { sentences, timings };
}
//# sourceMappingURL=sentenceTimings.js.map